import sendBeacon from './sendBeacon';
import sendFetch from './sendFetch';
import getEnvelope from './envelope';
import constructData from './constructData';
import { EventData, WeapiEventPayload } from './contracts';

const startTracking = (
  env,
  url,
  track,
  project,
  correlationId,
  payloadMetaAttributes,
  debug,
) => {
  const trackData = async data => {
    const { eventName, customAttributes = {}, overrides = {}, options = {} } =
      data || {};
    const { useFetch = false, fetchOption = { keepalive: true } } = options;
    const envelope = await getEnvelope(
      env,
      project,
      track,
      eventName,
      correlationId,
      overrides,
    );
    const eventPayload: WeapiEventPayload = constructData(
      envelope,
      customAttributes,
      payloadMetaAttributes,
    );
    const fullData: EventData = {
      query: `mutation weapiEvent($EventPayload: EventPayload!) { event( payload: $EventPayload ) }`,
      operationName: 'weapiEvent',
      variables: { EventPayload: eventPayload },
    };
    const isProdLikeEnv =
      env === 'production' || env === 'prod' || env === 'uat';

    if (debug && !isProdLikeEnv) {
      console.debug(
        `Eventable clickstream payload for ${eventName}: `,
        eventPayload,
      );
    }
    // Add eventName as a query param so it's easier to find in Chrome dev tools.
    useFetch || !navigator.sendBeacon
      ? sendFetch(`${url}?${eventName}`, fullData, fetchOption)
      : sendBeacon(`${url}?${eventName}`, fullData);
  };

  return trackData;
};

export default startTracking;
